export default {
  'Choose File': 'اختر ملف',
  'Please paste a URL': 'من فضلك الصق عنوان URL',
  'Loading': 'جار التحميل',
  'Analyzing': 'تحليل',
  'Try a sample': 'تجربة عينة',
  'Sorry, error occurs when analyzing the URL.': 'عذراً، حدث خطأ عند تحليل عنوان URL.',
}